/**
 * UsersMeRequest
 */
import React from 'react';
import { connect } from 'react-redux';

// Actions
import { loadUsersMe } from '../../services/usersMe/actions';

interface Props {
    loadUsersMe: Function;
}

export class UsersMeRequest extends React.PureComponent<Props> {
    componentDidMount() {
        this.props.loadUsersMe();
    }

    render() {
        return null;
    }
}
export default connect(
    null,
    { loadUsersMe }
)(UsersMeRequest);
